<template>
    <div style="display: flex; align-items: center; gap: 4px;">
        <div :class="isEnd ? 'end' : 'time_box'">
            <div>{{ timeRemainingHour }}</div>
        </div>
        <div style="margin-bottom: 3px;">:</div>
        <div :class="isEnd ? 'end' : 'time_box'">
            <div>{{ timeRemainingMinute }}</div>
        </div>
        <div style="margin-bottom: 3px;">:</div>
        <div :class="isEnd ? 'end' : 'time_box'">
            <div>{{ timeRemainingSecond }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalculateRemainTime',
    props: {
        beginTime: {
            type: String,
            default: ''
        },
        setIsJoin: {
            type: Function,
            default: () => { }
        },
        index: {
            type: Number,
            default: -1
        },
    },
    data() {
        return {
            timeRemainingHour: '',
            timeRemainingMinute: '',
            timeRemainingSecond: '',
            isEnd: false,
            timer: null
        }
    },
    methods: {
        calculateTimeRemaining() {
            const currentTime = new Date();
            const eventTime = new Date(this.beginTime);

            const timeDiff = eventTime - currentTime;

            if (timeDiff <= 0) {
                this.timeRemainingHour = '00'
                this.timeRemainingMinute = '00'
                this.timeRemainingSecond = '00'
                this.isEnd = true
                this.setIsJoin(this.isEnd, this.index)
                clearInterval(this.timer);
                return;
            }

            const hours = Math.floor(timeDiff / (1000 * 60 * 60));
            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

            this.timeRemainingHour = String(hours).padStart(2, '0')
            this.timeRemainingMinute = String(minutes).padStart(2, '0')
            this.timeRemainingSecond = String(seconds).padStart(2, '0')
        },
        startTimer() {
            this.calculateTimeRemaining();
            this.timer = setInterval(this.calculateTimeRemaining.bind(this), 1000);
        },
        stopTimer() {
            clearInterval(this.timer);
        }
    },
    created() {
        this.startTimer();
    },
    beforeDestroy() {
        this.stopTimer();
    }
}
</script>

<style scoped>
.time_box {
    padding: 4px;
    background-color: #210f03;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
}

.end {
    padding: 4px;
    background-color: #606060;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>